import { Route, Routes as ReactDOMRoutes } from 'react-router-dom';
import LoginView from './Login/LoginView';
import MainView from './Main/MainView';
import ItemsView from './Main/Items/ItemsView';

import AccountView from './Main/Account/AccountView';
import TabsLayout from './Main/components/TabsLayout';
import ItemView from './Main/Items/Item';
import DeliveryReceiptView from './Main/Items/DeliveryReceipt';
import ItemLayout from './Main/Items/Item/components/ItemLayout';
import { useTranslation } from 'react-i18next';

const Routes = () => {
  const { t } = useTranslation();

  return (
    <ReactDOMRoutes>
      <Route path="/" element={<LoginView />} />
      <Route path="/login" element={<LoginView />} />

      <Route path="/" element={<MainView />}>
        <Route element={<TabsLayout title={t('Image upload')} />}>
          <Route path="items" element={<ItemsView />} />
        </Route>

        <Route element={<TabsLayout title={t('Reception')} />}>
          <Route path="account" element={<AccountView />} />
        </Route>

        <Route element={<TabsLayout title={t('Delivery receipt')} />}>
          <Route path="delivery-receipt" element={<ItemsView />} />
        </Route>

        <Route element={<ItemLayout title={t('Image upload')} />}>
          <Route path="items/:itemId/*" element={<ItemView />} />
        </Route>

        <Route
          path="delivery-receipt/:itemId/*"
          element={<DeliveryReceiptView />}
        />

        <Route path="*" element={<span>Not found inside /</span>} />
      </Route>

      <Route path="*" element={<span>Not found</span>} />
    </ReactDOMRoutes>
  );
};

export default Routes;
